import { Island } from '../island.class';

export const isGrillIslandCfn = (island: Island): boolean => {
	// Use panels to find grill appliances, return true if one is found
	console.log('TODO: isGrillIsland', island);

	return false;
};
